export const companySearch = {
  'companySearch.title': 'Company Information',
  'companySearch.searchPlaceholder': 'Search by company name, SIREN, or address...',
  'companySearch.searchButton': 'Search',
  'companySearch.useManualEntry': 'Enter Manually',
  'companySearch.useCompanySearch': 'Use Company Search',
  'companySearch.searchLabel': 'Search French Companies',
  'companySearch.updateLabel': 'Update Company Information',
  'companySearch.updatePlaceholder': 'Search to update company information...',
  'companySearch.noResults': 'No companies found for',
  'companySearch.noResultsHint': 'Try searching with a different company name or SIREN number',
  'companySearch.selected': 'Company Selected',
  'companySearch.selectedDesc': 'Selected {{name}} (SIREN: {{siren}})',
  'companySearch.searchError': 'Search Error',
  'companySearch.searchErrorDesc': 'Failed to search companies. Please try again.',
  'companySearch.searchFailed': 'Search Failed',
  'companySearch.searchFailedDesc': 'Unable to search companies at the moment.',
  'companySearch.rateLimited': 'Rate limit exceeded. Please try again in a few seconds.',
  'companySearch.employees.NN': 'Not specified',
  'companySearch.employees.00': 'No employees',
  'companySearch.employees.01': '1-2 employees',
  'companySearch.employees.02': '3-5 employees',
  'companySearch.employees.03': '6-9 employees',
  'companySearch.employees.11': '10-19 employees',
  'companySearch.employees.12': '20-49 employees',
  'companySearch.employees.21': '50-99 employees',
  'companySearch.employees.22': '100-199 employees',
  'companySearch.employees.31': '200-249 employees',
  'companySearch.employees.32': '250-499 employees',
  'companySearch.employees.41': '500-999 employees',
  'companySearch.employees.42': '1000-1999 employees',
  'companySearch.employees.51': '2000-4999 employees',
  'companySearch.employees.52': '5000-9999 employees',
  'companySearch.employees.53': '10000+ employees'
} as const;